module.exports = __webpack_public_path__ + "static/img/moment1.64393e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/moment1.png
// module id = 8url
// module chunks = 1